/**
 * Quais seções de cada iniciativa o cliente vê.
 *
 * Morava dentro do Layout, e o seletor de iniciativa do mover e do "Abrir um
 * chamado" (ADR-096) precisa da mesma resposta: iniciativa sem a aba
 * Atendimento não recebe chamado, porque ali ele não apareceria em lista
 * nenhuma. Uma regra só, para o menu e o seletor nunca discordarem.
 */

export function resolveSections(visible) {
  const v = visible || {}
  const globalInitiativeFlags = v.initiatives ?? {
    // fallback derivado das chaves antigas (Onda 1)
    discovery: v.discovery_overview === true,
    progress: v.progress !== false,
    docs: false,
    validation: v.testing === true,
  }
  return {
    showDashboard: v.dashboard !== false,
    showAdmin: v.admin !== false,
    globalInitiativeFlags,
    initiativesById: v.initiatives_by_id || {},
  }
}

// Resolve flags por iniciativa: override > global > defaults conservadores.
export function flagsForInitiative(sections, initiativeId) {
  const defaults = { discovery: false, progress: true, docs: false, validation: false }
  const override = sections.initiativesById?.[String(initiativeId)] || null
  return { ...defaults, ...sections.globalInitiativeFlags, ...(override || {}) }
}

/**
 * Esta seção aparece nesta iniciativa?
 *
 * Toda seção aparece a não ser que a flag seja explicitamente false, e desde o
 * D4 do ciclo de horas (21/09/2026) o Atendimento segue a mesma regra, em
 * qualquer fase: todo cliente consegue pedir. Até ali a aba só aparecia sozinha
 * em iniciativa entregue ou em suporte, e decidiam as chaves antigas
 * (`validation` e `suporte`); a tela do time nascia com ela desligada, e o
 * cliente em construção ficava sem porta. O `initiative` fica na assinatura
 * porque o menu e o seletor já o passam.
 */
export function secaoLigada(chave, initiativeFlags, _initiative) {
  return initiativeFlags[chave] !== false
}

/** A iniciativa tem a aba Atendimento, ou seja, recebe chamado pelo portal? */
export function atendimentoLigado(project, initiative) {
  if (!initiative) return false
  const sections = resolveSections(project?.visible_sections)
  return secaoLigada('atendimento', flagsForInitiative(sections, initiative.id), initiative)
}
